import userTypes from './types';

export const initialStates = {
	session: null,
	users: [],
	forgetPassword: null,
	selectedBusinessId: '',
	profile: {},
	updateProfile: null,
	updateProfileOtp: null,
	updateProfileOtpConfirm: null,
	wizard: null,
	registerFresh: null,
	completeProfile: null,
};

const userReducers = (state = initialStates, action) => {
	switch (action.type) {
		case userTypes.GET_PROFILE.SUCCESS: {
			return { ...state, completeProfile: action?.payload?.data?.attributes };
		}

		case userTypes.UPDATE_PROFILE.SUCCESS: {
			return {
				...state,
				...getUsersInfoByLogin(action?.payload),
			};
		}

		case userTypes.REGISTER_FRESH.SUCCESS: {
			return { ...state, registerFresh: action?.payload };
		}

		case userTypes.REGISTER_FRESH.CLEAR: {
			return { ...state, registerFresh: null };
		}

		case userTypes.FORGET_PASSWORD.SUCCESS: {
			return { ...state, forgetPassword: action?.payload?.msg };
		}

		case userTypes.FORGET_PASSWORD.CLEAR: {
			return { ...state, forgetPassword: null };
		}

		case userTypes.SESSION.SELECT_BUSINESS: {
			const businessId = action?.payload;
			const selectedSession = state.users.find(
				(user) =>
					user?.business_id == businessId || user?.business?.id == businessId
			);
			return {
				...state,
				session: selectedSession,
				selectedBusinessId: businessId,
			};
		}

		case userTypes.SESSION.LOGOUT: {
			return { ...initialStates };
		}

		case userTypes.PROFILE.SUCCESS: {
			return { ...state, profile: action?.payload?.data };
		}
		case userTypes.PROFILE_UPDATE.SUCCESS: {
			return { ...state, updateProfile: action?.payload };
		}

		case userTypes.PROFILE_UPDATE.CLEAR: {
			return { ...state, updateProfile: null };
		}

		case userTypes.CHANGE_NUMBER_OTP.SUCCESS: {
			return { ...state, updateProfileOtp: action?.payload };
		}

		case userTypes.CHANGE_NUMBER_OTP_CONFIRM.SUCCESS: {
			return { ...state, updateProfileOtpConfirm: action?.payload };
		}

		case userTypes.CHANGE_NUMBER_OTP.CLEAR: {
			return { ...state, updateProfileOtp: null };
		}

		case userTypes.CHANGE_NUMBER_OTP_CONFIRM.CLEAR: {
			return { ...state, updateProfileOtpConfirm: null };
		}

		case userTypes.WIZARD.SUCCESS: {
			return { ...state, wizard: action?.payload?.data };
		}

		case userTypes.WIZARD.CLEAR: {
			return { ...state, wizard: null };
		}

		default:
			return state;
	}
};

export default userReducers;

const getUsersInfoByLogin = (user) => {
	let users = [user],
		session = user,
		selectedBusinessId = user?.business_id || user?.business?.id;

	if (user?.super_user) {
		const subUsers = user.sub_users.map((user) => user.attributes);
		users.push(...subUsers);
	}

	return { users, session, selectedBusinessId };
};
